import React from "react";

export default () => {
  return (
    <div className="login">
      <h1>Please check your email for a verification link.</h1>
    </div>
  );
};
